import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const Toastify = () => {
    return <ToastContainer theme="dark" />
}

export default Toastify
